import React, { useEffect } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import {
  FaBookOpen,
  FaBookReader,
  FaClipboardCheck,
  FaHome,
  FaLayerGroup,
  FaListUl,
  FaTasks,
  FaUserCheck,
} from "react-icons/fa";
import BackButton from "../ChildComponent/BackButton";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";

//Created By Cursor
const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

//Created By Cursor
const PAGE_FONT =
  '"Segoe UI", system-ui, -apple-system, Roboto, "Helvetica Neue", Arial, sans-serif';

//Created By Cursor — related existing modules
const RELATED_MODULES = [
  {
    id: "lesson-plan",
    title: "Lesson Plan",
    hint: "Create plans, assign tasks, track completion",
    to: "/AdminMain/LessonPlan",
    icon: FaBookReader,
    tone: "lessonplan",
  },
  {
    id: "homework",
    title: "Homework",
    hint: "Assign and review class homework",
    to: "/AdminMain/HomeWork",
    icon: FaBookOpen,
    tone: "homework",
  },
  {
    id: "notice",
    title: "Notice Board",
    hint: "Publish notices and school updates",
    to: "/AdminMain/NoticeBoard/1",
    icon: FaClipboardCheck,
    tone: "notice",
  },
];

//Created By Cursor — wired to Lesson Plan hub tabs
const CAPABILITY_AREAS = [
  {
    id: "assign",
    title: "Assign activities",
    hint: "Create lesson plan tasks for staff",
    icon: FaListUl,
    to: "/AdminMain/LessonPlan?tab=plans",
  },
  {
    id: "track",
    title: "Track progress",
    hint: "Monitor open, due, and in-progress assignments",
    icon: FaTasks,
    to: "/AdminMain/LessonPlan?tab=tasks",
  },
  {
    id: "review",
    title: "Review & close",
    hint: "Approve submitted plans and close tasks",
    icon: FaUserCheck,
    to: "/AdminMain/LessonPlan?tab=tasks",
  },
];

//Created By Cursor
export default function ActivityManagement() {
  const history = useHistory();
  const loggedIn = localStorage.getItem("token") != null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <div
      className="content payroll-page sm-page am-page"
      style={{ fontFamily: PAGE_FONT }}
    >
      <div
        className="content-header d-flex justify-content-between align-items-center"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header d-flex align-items-center gap-2">
          <button
            type="button"
            className="qb-home-btn"
            aria-label="Home"
            onClick={() => history.push("/AdminMain")}
          >
            <FaHome />
          </button>
          <ul className="breadcrumbs mb-0">
            <li>
              <button
                type="button"
                className="am-crumb"
                onClick={() => history.push("/AdminMain/Academic/1")}
              >
                Academic
              </button>
            </li>
            <li>
              <span style={{ color: COLORS.white }}>Activity Management</span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell am-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon" aria-hidden>
              <FaTasks />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Activity Management</h1>
              <p className="sm-hero__sub">
                Plan, assign, and follow school activities from one place
              </p>
            </div>
          </div>
        </header>

        <div className="am-body">
          <section className="am-intro" aria-label="Overview">
            <div className="am-intro__icon" aria-hidden>
              <FaLayerGroup />
            </div>
            <div className="min-w-0">
              <h2 className="am-intro__title">Workspace ready</h2>
              <p className="am-intro__text">
                Use Lesson Plan for structured teaching plans and staff task
                workflows. Homework and notices remain available for day-to-day
                class activity.
              </p>
            </div>
          </section>

          <section className="am-section" aria-labelledby="am-related-heading">
            <div className="am-section__head">
              <h2 id="am-related-heading">Related modules</h2>
              <p>Open activity tools already in EduOK</p>
            </div>
            <div className="am-related-grid">
              {RELATED_MODULES.map((mod, index) => {
                const Icon = mod.icon;
                return (
                  <Link
                    key={mod.id}
                    to={mod.to}
                    className={`am-related am-related--${mod.tone}`}
                    style={{ "--am-i": index }}
                    aria-label={mod.title}
                    title={mod.hint}
                  >
                    <span className="am-related__icon" aria-hidden>
                      <Icon />
                    </span>
                    <span className="am-related__body">
                      <span className="am-related__title">{mod.title}</span>
                      <span className="am-related__hint">{mod.hint}</span>
                    </span>
                  </Link>
                );
              })}
            </div>
          </section>

          <section className="am-section" aria-labelledby="am-cap-heading">
            <div className="am-section__head">
              <h2 id="am-cap-heading">Lesson plan workflows</h2>
              <p>Assign, track, and review teaching tasks</p>
            </div>
            <div className="am-cap-grid">
              {CAPABILITY_AREAS.map((cap, index) => {
                const Icon = cap.icon;
                return (
                  <Link
                    key={cap.id}
                    to={cap.to}
                    className="am-cap am-cap--link"
                    style={{ "--am-i": index }}
                    aria-label={cap.title}
                    title={cap.hint}
                  >
                    <span className="am-cap__icon" aria-hidden>
                      <Icon />
                    </span>
                    <div className="min-w-0">
                      <h3 className="am-cap__title">{cap.title}</h3>
                      <p className="am-cap__hint">{cap.hint}</p>
                      <span className="am-cap__badge am-cap__badge--live">
                        Open
                      </span>
                    </div>
                  </Link>
                );
              })}
            </div>
          </section>
        </div>
      </div>

      <style>{`
        .am-cap--link { text-decoration: none; color: inherit; transition: border-color 0.15s, box-shadow 0.15s; }
        .am-cap--link:hover { border-color: #cbd5e1; box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06); }
        .am-cap__badge--live { background: #dcfce7; color: #15803d; }
      `}</style>
    </div>
  );
}
